module.exports = __webpack_public_path__ + "img/icon_form_invalid.15e4640e.svg";